const Icon = ({name}) => {
  return <span className={'icon ' + name}></span>
}

export default Icon
